import React, { useEffect, useState } from 'react';
import config from '../../../../shared/services/config';
import { useGetOutlets, useSearcdhOutlets } from '../../../../shared/hooks/api/useOutlet';
import AuthManager from '../../../../shared/services/AuthManager';
import { MerchantDetailCard } from 'hub-redux-auth/lib/post-login/pages/outlets/components/elements';
import { SearchInput } from 'hub-redux-auth/lib/post-login/pages/team-accounts/components/search-input';

const defaultPageSize = 10

export const MobileOutletsTable = ({ mid, history, onOutletSelect }) => {
  const [filter, setFilter] = useState({
    pageNo: 0,
    pageSize: defaultPageSize,
    searchTerm: null,
  })
  const updateFilter = p => setFilter(s => ({ ...s, ...p }))
  const [outletData, setOutletData] = useState({
    list: [],
    records: 0,
  })
  const [getOutlets, { isFetching }] = useGetOutlets({
    mid, authToken: AuthManager.getAppToken(), onSuccess: ({ data }) => {
      setOutletData(s => ({ list: [...s.list, ...(data?.data?.result)], records: data?.data?.records }))
    }
  });
  const [searchOutlets, { isFetching: isSearchDataFetching }] = useSearcdhOutlets({
    mid, authToken: AuthManager.getAppToken(), onSuccess: ({ data }) => {
      setOutletData(s => ({ list: [...s.list, ...(data?.data?.result)], records: data?.data?.records }))
    }
  });
  useEffect(() => {
    if (filter.searchTerm) {
      searchOutlets(filter)
    } else {
      getOutlets(filter)
    }
  }, [filter.pageNo, filter.pageSize, filter.searchTerm]);

  const loadMore = () => {
    setFilter(s => ({ ...s, pageNo: s.pageNo + 1 }))
  }


  const [filterSubOutlet, setFilterSubOutlet] = useState({
    pageNo: 0,
    pageSize: defaultPageSize
  })

  const [subOutletData, setSubOutletData] = useState({
    list: [],
    records: 0,
  })
  const [getSubOutlets, { isFetching: isSubOutletsFetching }] = useGetOutlets({
    mid, authToken: AuthManager.getAppToken(), onSuccess: ({ data }) => {
      setSubOutletData(s => ({ list: [...s.list, ...(data?.data?.result)], records: data?.data?.records }))
    }
  });

  const [selectedOutlet, setSelectedOutlet] = useState(null)
  useEffect(() => {
    if (filterSubOutlet.outletId) {
      if (filter.pageNo == 0) {
        setSubOutletData({ list: [], records: 0 })
      }
      getSubOutlets(filterSubOutlet)
    }
  }, [filterSubOutlet.pageNo, filterSubOutlet.pageSize, filterSubOutlet.outletId])
  const loadMoreSubOutlets = () => {
    setFilterSubOutlet(s => ({ ...s, pageNo: s.pageNo + 1 }))
  }

  const userData = AuthManager.getUser();
  const UI = config.get('uiv2', {})


  const [searchTerm, setSearchTerm] = useState(null)
  const handleDebouncedSearch = (debouncedSearchTerm) => {
    if (debouncedSearchTerm != null) {
      console.log('debounced', debouncedSearchTerm, searchTerm)
      setSelectedOutlet(null)
      setOutletData({
        list: [],
        records: 0
      })
      updateFilter({
        searchTerm: debouncedSearchTerm,
        pageNo: 0,
        pageSize: defaultPageSize
      });
    }
  }

  useEffect(() => {
    const id = setTimeout(() => {
      handleDebouncedSearch(searchTerm)
    }, 500)
    return () => clearTimeout(id)
  }, [searchTerm])
  return (
    <>
      <MerchantDetailCard
        mid={mid}
        businessName={userData?.name}
        aclRoleName={userData?.acl_role_name}
        isMobile
      />
      <div className='tw-px-16 tw-pt-16 tw-pb-64'>
        <UI.Typography variant='P2' className='tw-pb-4 tw-text-green-gray-300'>
          {selectedOutlet?.outletId ? 'Select the Sub-Outlet dashboard you want to view' : 'Select the Outlet dashboard you want to view'}
        </UI.Typography>
        <SearchInput
          onChange={e => setSearchTerm(e.target.value)}
          placeholder='Search Outlets'
          fullWidth
          disabled={isSearchDataFetching}
        />
        {selectedOutlet?.outletId ? (
          <UI.BaseTable
            bodyData={subOutletData.list}
            headData={[{ id: 'outletName', mobile: 1 }, { id: 'address', mobile: 3 }]}
            clickableRow={{
              enable: true,
              onRowClick: onOutletSelect
            }}
            pagination={{
              enable: true,
              totalRows: subOutletData.records,
              onBottomHit: loadMoreSubOutlets
            }}
            isLoading={isSubOutletsFetching}
          />
        ) :
          <UI.BaseTable
            bodyData={outletData.list}
            headData={[{ id: 'outletName', mobile: 1 }, { id: 'address', mobile: 3 }]}
            clickableRow={{
              enable: true,
              onRowClick: (v) => {
                if (v.haveChild) {
                  setSelectedOutlet(v);
                  setFilterSubOutlet(s => ({
                    ...s,
                    outletId: v.outletId,
                    pageNo: 0
                  }))
                } else {
                  onOutletSelect(v)
                }
              }
            }}
            pagination={{
              enable: true,
              totalRows: outletData.records,
              onBottomHit: loadMore
            }}
            isLoading={isFetching || isSearchDataFetching}
          />
        }
      </div>
      <div className='tw-fixed tw-bottom-0 tw-flex tw-justify-between tw-p-16 tw-gap-16 tw-flex-wrap tw-w-screen tw-bg-gray-20'>
        {
          selectedOutlet?.outletId ? <>
            <UI.Button variant='SECONDARY' onClick={() => {
              setSelectedOutlet(null)
              setSubOutletData({ list: [], records: 0 })
              setFilterSubOutlet({ outletId: null, pageNo: 0, pageSize: defaultPageSize })
            }}>Back to all Oulets</UI.Button>
            <UI.Button onClick={() => onOutletSelect(selectedOutlet)}>View Master Outlet Dash</UI.Button>
          </> : <>
            <UI.Button variant='SECONDARY' onClick={() => history.push({
              pathname: '/account/team-accounts',
            })}>Back to all MIDs</UI.Button>
            <UI.Button onClick={onOutletSelect}>View Master MID Dash</UI.Button>
          </>
        }
      </div >
    </>
  )
}